<template>
	<div v-if="token.secret_application">
		<p>
			Save the following tokens in a safe space. They won't be showed again!
		</p>

		<BaseFormComponent id="api_token_secret_application" label="Token for application">
			<BaseInput
				v-model="secretApplication"
				id="api_token_secret_application"
				readonly
			/>
		</BaseFormComponent>

		<BaseFormComponent id="api_token_secret_connector" label="Token for connector">
			<BaseInput
				v-model="secretConnector"
				id="api_token_secret_connector"
				readonly
			/>
		</BaseFormComponent>
	</div>

	<form v-else @submit.prevent="submit">
		<BaseFormComponent id="api_token_name" label="Name">
			<BaseInput
				type="text"
				v-model="token.name"
				id="api_token_name"
				maxlength="128"
				required
			/>
		</BaseFormComponent>

		<BaseFormButtons />
	</form>
</template>

<script>
import { getErrors } from '@/core/http'
import BaseFormComponent from '@/core/components/BaseFormComponent'
import BaseInput from '@/core/components/BaseInput'
import BaseFormButtons from '@/core/components/BaseFormButtons'
import apiTokensHttp from '@/modules/api_token/apiTokensHttp'

export default {
	name: 'ApiTokenForm',
	components: {
		BaseFormButtons,
		BaseFormComponent,
		BaseInput,
	},
	emits: [
		'saved',
	],
	data() {
		return {
			token: {
				name: '',
			},
		};
	},
	computed: {
		secretApplication() {
			return this.token.id + this.token.secret_application;
		},
		secretConnector() {
			return this.token.id + this.token.secret_connector;
		},
	},
	methods: {
		submit() {
			apiTokensHttp.post(this.token)
				.then(apiToken => {
					this.token = apiToken;

					this.$emit('saved', apiToken);

					this.$flashMessage.show({
						type: 'success',
						text: 'The API token was saved!',
					});
				})
				.catch(response => {
					const errors = getErrors(response);

					errors.forEach((text) => {
						this.$flashMessage.show({
							type: 'error',
							text,
						});
					});
				})
			;
		},
	},
};
</script>
